
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Badgebase4285117639",
      {"classes":{"root":"Badgebase4285117639__root","innerContainer":"Badgebase4285117639__innerContainer","icon":"Badgebase4285117639__icon"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  